import React, { useMemo } from 'react';
import { Grid, IconType, ISpruceFieldProps, RotatingIcon, Select, SpruceField } from 'ui-toolkit';
import { createDefaultPageData } from 'types/rest/IPageData';
import { PreExistingContactDisplay } from '../subComponents/PreExistingContactDisplay';
import { eAdminAccountStatus } from '../../../../types/administration/userAdministration/IAdminUser';
import { useListPagedAdminUsersQuery } from '../../../../API/administration/AdminUsersAPI';

interface IAddContactFormAdminSectionProps {
  onSelectAdmin: (adminId: string) => void;
}

export const AddContactFormAdminSection: React.FC<IAddContactFormAdminSectionProps> = ({ onSelectAdmin }) => {
  const { data: adminUsers = createDefaultPageData(), isFetching: adminsIsFetching } = useListPagedAdminUsersQuery({
    status: eAdminAccountStatus.Active,
    fetchAll: true,
  });
  const options = useMemo(() => {
    return adminUsers.content.map(({ id, fullName }) => ({ label: fullName, value: id }));
  }, [adminUsers]);

  return (
    <Grid templateColumns={adminsIsFetching ? '1fr min-content' : '1fr'} alignItems={'center'}>
      <SpruceField name={'adminId'} inputType={'select'}>
        {({ field }: ISpruceFieldProps) => {
          const contact = adminUsers.content.find((admin) => admin.id === field.value);
          return (
            <Grid>
              <Select
                {...field}
                onChange={(value: any) => {
                  field.onChange(value);
                  onSelectAdmin(value.value);
                }}
                value={field.value ? options.find((admin) => admin.value === field.value) : null}
                options={options}
                isClearable={true}
                label={'Find Existing Contact'}
              />
              {field.value && !!contact && (
                <PreExistingContactDisplay fullName={contact.fullName} email={contact.email} />
              )}
            </Grid>
          );
        }}
      </SpruceField>
      {adminsIsFetching && <RotatingIcon type={IconType.Loading} />}
    </Grid>
  );
};
